"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var withApollo_1 = __importDefault(require("./withApollo"));
exports.withApollo = withApollo_1.default;
var apollo_1 = require("./apollo");
exports.initApollo = apollo_1.default;
exports.default = withApollo_1.default;
